import React from 'react';
import {observer, inject} from 'mobx-react';
import {Form, Button, Input, Modal} from '@enos/dpl';
import localeText from '@locale';
import CipherInput from '~/components/CipherInput';
import store from './store';
import encrypt, {rsaEncrypt} from '~/utils/encrypt';
import {Mobile, DesktopOrTablet} from '~/components/Responsive';
import MobileNavBack from '~/components/MobileNavBack';

import './index.less';
import './mobile.less';

const FormItem = Form.Item;

@inject((stores, props) => {
  const {userStore, sessionStore, securityStore} = stores;
  return {
    ...props,
    sessionStore,
    securityStore,
    userStore,
    uiStore: store
  };
})
@Form.create()
@observer
class ChangeCipher extends React.Component {
  static defaultProps = {
    prefixClass: 'route-change-password'
  };

  handleSubmit = (e) => {
    const {form, userStore, uiStore, sessionStore} = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll({first: true}, (err, values) => {
      if (!err) {
        userStore.modifyPassword(rsaEncrypt(values.oldPassword), rsaEncrypt(values.newPassword), encrypt.config.publicKeyId).then(() => {
          uiStore.toggleChangePasswordModal(false);
          form.resetFields();
          sessionStore.logout();
        });
      }
    });
  };

  handleCancel = () => {
    const {uiStore} = this.props;
    uiStore.toggleChangePasswordModal(false);
    this.passwordRef.clearMatchStatus();
  };

  compareToNewPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('newPassword')) {
      callback(localeText('USER.MSG_NEW_CIPHER_NOT_SIMILAR'));
    } else {
      callback();
    }
  };

  compareToOldPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value === form.getFieldValue('oldPassword')) {
      callback(localeText('USER.MSG_NEW_OLD_CIPHER_SIMILAR'));
    } else {
      callback();
    }
  };

  validatePasswordRules = (rules, value, callback) => {
    if (this.passwordRef.validate()) {
      callback();
    } else {
      callback(localeText('USER.MSG_INVALIDATE_CIPHER'));
    }
  };

  render() {
    const {prefixClass, uiStore} = this.props;
    return (
      <Modal
        className='modify-password small-modal'
        maskClosable={false}
        visible={uiStore.showChangePasswordModal}
        footer={null}
        onCancel={() => uiStore.toggleChangePasswordModal(false)}
        afterClose={() => {
          this.props.form.resetFields();
        }}
      >
        <div className={prefixClass}>
          <Mobile>
            <div className='changepwd-header'>
              <MobileNavBack title={localeText('COMMON.BTN_CHANGE_CIPHER')} onBack={() => uiStore.toggleChangePasswordModal(false)} />
            </div>
          </Mobile>
          <DesktopOrTablet>
            <div className='modify-password-title'> {localeText('COMMON.BTN_CHANGE_CIPHER')}</div>
          </DesktopOrTablet>
          <Form className='form-change-password' onSubmit={this.handleSubmit}>
            <FormItem label={localeText('USER.LABEL_OLD_CIPHER')} colon={false}>
              {this.props.form.getFieldDecorator('oldPassword', {
                validateFirst: true,
                rules: [
                  {
                    required: true,
                    message: localeText('USER.MSG_NO_CIPHER')
                  }
                ]
              })(
                <Input
                  onCopy={() => false}
                  onPaste={() => false}
                  onCut={() => false}
                  autoComplete='off'
                  autoCorrect='off'
                  placeholder={localeText('USER.MSG_ENTER_OLD_CIPHER')}
                  type='password'
                />
              )}
            </FormItem>

            <FormItem label={localeText('USER.LABEL_NEW_CIPHER')} colon={false} className='passWord-input-layout'>
              {this.props.form.getFieldDecorator('newPassword', {
                validateFirst: true,
                initialValue: '',
                rules: [
                  {
                    required: true,
                    message: localeText('USER.MSG_NO_CIPHER')
                  },
                  {
                    validator: this.compareToOldPassword
                  },
                  {
                    validator: this.validatePasswordRules
                  }
                ]
              })(
                <CipherInput
                  onCopy={() => false}
                  onPaste={() => false}
                  onCut={() => false}
                  ref={(e) => {
                    this.passwordRef = e;
                  }}
                  autoComplete='off'
                  autoCorrect='off'
                  type='password'
                  placeholder={localeText('USER.MSG_ENTER_NEW_CIPHER')}
                  onChange={(e) => {
                    this.props.form.setFieldsValue({newPassword: e.target.value});
                  }}
                />
              )}
            </FormItem>

            <FormItem label={localeText('USER.LABEL_CONFIRM_NEW_CIPHER')} colon={false}>
              {this.props.form.getFieldDecorator('checkNewPassword', {
                validateFirst: true,
                rules: [
                  {
                    required: true,
                    message: localeText('USER.MSG_NO_CIPHER')
                  },
                  {
                    validator: this.compareToNewPassword
                  }
                ]
              })(
                <Input
                  onCopy={() => false}
                  onPaste={() => false}
                  onCut={() => false}
                  autoComplete='off'
                  autoCorrect='off'
                  placeholder={localeText('USER.MSG_ENTER_CIPHER_AGAIN')}
                  type='password'
                />
              )}
            </FormItem>

            <DesktopOrTablet>
              <div className='modify-password-button'>
                <Button className='cancel-button' onClick={this.handleCancel}>
                  {localeText('COMMON.BTN_CANCEL')}
                </Button>

                <Button className='submit-button' type='primary' htmlType='submit' onClick={this.handleSubmit}>
                  {localeText('COMMON.BTN_SUBMIT')}
                </Button>
              </div>
            </DesktopOrTablet>
            <Mobile>
              <div>
                <Button className='mobile-submit-button' type='primary' htmlType='submit' onClick={this.handleSubmit}>
                  {localeText('COMMON.BTN_SUBMIT')}
                </Button>
              </div>
            </Mobile>
          </Form>
        </div>
      </Modal>
    );
  }
}

export function showChangePasswordModal() {
  store.toggleChangePasswordModal(true);
}

export default ChangeCipher;
